import { Component, HostBinding } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ly-button-group',
  standalone: true,
  imports: [CommonModule],
  template: '<ng-content></ng-content>',
  styleUrl: './button-group.component.scss',
})
export class ButtonGroupComponent {
  @HostBinding('attr.role') role = 'group';
  @HostBinding('class.button-group') className = true;
}
